// removed by extract-text-webpack-plugin
module.exports = {"Start":"purify_Start__Start___-1UyT","intro-button":"purify_Start__intro-button___2awvn"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Start/Start.scss
// module id = 288
// module chunks = 0